export const ErrorMessageMsisdn = [
    {
        name: 'minlength',
        message: 'error.msisdn.length'
    },
    {
        name: 'pattern',
        message: 'error.msisdn.invalid'
    },
    {
        name: 'email',
        message: 'error.email'
    }
];